// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

import "../../style/sassStyle";

import { ROUTE_DEFINITIONS, getPath } from "routes/routes";
import { Theme, createStyles, makeStyles } from "@material-ui/core";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { CustomerConfig } from "utils/ConfigTypes";
import React from "react";
import Title from "components/ui/Title";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    orgCard: {
      minHeight: "175px",
      display: "flex",
      flexDirection: "column",
      cursor: "pointer",
    },
  })
);

export interface OrgCardProps {
  customerConfig: CustomerConfig;
}

export const OrgCard = (props: OrgCardProps) => {
  const classes = useStyles();
  const { customerConfig } = props;
  const history = useHistory();

  return (
    <Card
      raised
      className={classes.orgCard}
      onClick={() => {
        const path = getPath(ROUTE_DEFINITIONS[customerConfig.landingPage], {
          customerPrefix: customerConfig.pathPrefix,
        });
        history.push(path);
      }}
    >
      <CardContent>
        <Title content={customerConfig.name} />
      </CardContent>
    </Card>
  );
};
